import React, { useState, useEffect, useRef } from "react";
import {
    Col,
    Label,
    Row,
    Form,
    Button,
    Spinner,
    FormGroup,
} from "reactstrap";
import { post, get } from "../../../Services/RestAPIService";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./SelectTime.css"; // Import your CSS file for styling

const SelectTime = ({ OnSubmit, Response, Data, Alerts, Loading, IsDisabled }) => {
    const animatedComponents = makeAnimated();
    const [timeSlots, setTimeSlots] = useState([]);
    const [timeSlotsSelected, setTimeSlotsSelected] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [excludedWeekdays, setExcludedWeekdays] = useState([]);
    const navigate = useNavigate();
    const monthListRef = useRef(null);
    const dateListRef = useRef(null);


    const isSubmitDisabled = () => {
        return !selectedDate || !endDate || !timeSlotsSelected || !excludedWeekdays;
    };
    IsDisabled(!selectedDate || !endDate || !timeSlotsSelected || !excludedWeekdays || !Data)



    useEffect(() => {
        getTimeSlots();
    }, []);


    const getTimeSlots = async () => {
        try {
            const response = await get(`appoint/times/`);
            const data = response.results;

            // Create a map to group time slots by their label
            const groupedTimeSlots = data.reduce((acc, slot) => {
                if (!acc[slot.label]) {
                    acc[slot.label] = [];
                }
                acc[slot.label].push({
                    label: slot.time,
                    value: slot.id // Convert id to string if needed
                });
                return acc;
            }, {});

            // Format the grouped data into the structure you need
            const formattedTimeData = Object.keys(groupedTimeSlots).map(label => ({
                label: "Available Time Data",
                category: label,
                options: groupedTimeSlots[label]
            }));

            // Set the formatted data to state
            setTimeSlots(formattedTimeData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };



    const daysBetween = (startDate, endDate) => {
        const date1 = new Date(startDate);
        const date2 = new Date(endDate);
        const timeDiff = Math.abs(date2.getTime() - date1.getTime());
        const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        return diffDays;
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     // Your form submission logic here
    // };

    const minEndDate = () => {
        if (selectedDate) {
            const nextDay = new Date(selectedDate);
            nextDay.setDate(nextDay.getDate());
            return nextDay;
        }
        return null;
    };

    const handleSubmit = async (e) => {
        setIsLoading(true)
        const formattedDateStart = `${selectedDate.getFullYear()}-${('0' + (selectedDate.getMonth() + 1)).slice(-2)}-${('0' + selectedDate.getDate()).slice(-2)}`;
        const formattedDateEnd = `${endDate.getFullYear()}-${('0' + (endDate.getMonth() + 1)).slice(-2)}-${('0' + endDate.getDate()).slice(-2)}`;
        e.preventDefault();
        Loading(true);

        const TimeIds = timeSlotsSelected.map((time) => time.value);

        const WeekdaysMap = excludedWeekdays.map((day) => day.value);


        const formData = {
            "start_date": formattedDateStart,
            "end_date": formattedDateEnd,
            "doctor_id": parseFloat(Data),
            "exclude_days": WeekdaysMap,
            "times_ids": TimeIds
        };
        console.log(formData, "formdata")
        try {
            const response = await post("appoint/bulk_create_timeslot/", formData);
            if (response.status <= 399) {
                Alerts({
                    color: "success",
                    visible: true,
                    message: "Categories submitted successfully.",
                    strongM: "Success!",
                });
                console.log(response, "response")
                Response(4)
                // Navigate to the next step if applicable
                // navigate('/next-step');

                setTimeSlotsSelected(null);
                setIsLoading(false);
                setSelectedDate(null);
                setEndDate(null);
                setExcludedWeekdays([]);

            } else {
                Alerts({
                    color: "danger",
                    visible: true,
                    message: "An error occurred.",
                    strongM: "Error!",
                });
            }


        } catch (error) {
            console.error('Error submitting categories:', error);
            Alerts({
                color: "danger",
                visible: true,
                message: "An error occurred.",
                strongM: "Error!",
            });
        } finally {
            setIsLoading(false);
            Loading(true);
        }
    };

    return (
        <React.Fragment>
            <Form id="SubmitTimeings" onSubmit={handleSubmit}>
                <Col lg="6">
                    <Label className="control-label">
                        {Data === null
                            ? "Please Register Consultent fot this Step"
                            : `Consultent is Registered with us and its Id is: ${Data}`}
                    </Label>

                    <FormGroup className="mb-3">
                        {/* Date picker for selecting start date */}
                        <Label className="control-label">Select Date</Label>
                        <DatePicker
                            selected={selectedDate}
                            onChange={(date) => setSelectedDate(date)}
                            minDate={new Date()}
                            dateFormat="yyyy-MM-dd"
                            className="form-control"
                        />
                    </FormGroup>

                    <FormGroup className="mb-3">
                        {/* Date picker for selecting end date */}
                        <Label className="control-label">Select End Date</Label>
                        <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            minDate={minEndDate()}
                            dateFormat="yyyy-MM-dd"
                            className="form-control"
                        />
                    </FormGroup>
                    <p>
                        Number of days between start and end dates: {daysBetween(selectedDate, endDate)}
                    </p>

                    <FormGroup className="mb-3 templating-select select2-container">
                        {/* Your select time component */}
                        <Label className="control-label">
                            Please Select Time you are Available in a Day. (Time Slots Selected:{" "}
                            {timeSlotsSelected?.length})
                        </Label>

                        <Select
                            value={timeSlotsSelected}
                            isMulti={true}
                            onChange={(selectedOptions) => setTimeSlotsSelected(selectedOptions)}
                            options={timeSlots}
                            classNamePrefix="select2-selection"
                            closeMenuOnSelect={false}
                            components={animatedComponents}
                            isLoading={isLoading}
                        />
                    </FormGroup>

                    <FormGroup className="mb-3">
                        {/* Select excluded weekdays */}
                        <Label className="control-label">Exclude Weekdays</Label>
                        <Select
                            value={excludedWeekdays}
                            isMulti={true}
                            onChange={(selectedOptions) => setExcludedWeekdays(selectedOptions)}
                            options={[
                                { value: "Monday", label: "Monday" },
                                { value: "Tuesday", label: "Tuesday" },
                                { value: "Wednesday", label: "Wednesday" },
                                { value: "Thursday", label: "Thursday" },
                                { value: "Friday", label: "Friday" },
                                { value: "Saturday", label: "Saturday" },
                                { value: "Sunday", label: "Sunday" },
                            ]}
                            classNamePrefix="select2-selection"
                            closeMenuOnSelect={false}
                        />
                    </FormGroup>

                    {/* <Button type="submit" color="primary" disabled={isLoading || isSubmitDisabled()}>
                        {isLoading ? <Spinner size="sm" color="gray" /> : "Submit"}
                    </Button> */}
                </Col>
            </Form>
        </React.Fragment>
    );
};

export default SelectTime;
